import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { CompanyDetails } from "../../models/compteEntreprise.model";
import { CustomerServiceService } from "../../services/customerService.service";
import { InfoPerso } from "../../models/InfoPerso.model";
import { StorageService } from "../../services/storage.service";
import { NgxMatIntlTelInputComponent } from "ngx-mat-intl-tel-input";
import { GS1LoadingService } from "@gs1france/gs1-components-library";

@Component({
    selector: 'unsubscribe',
    templateUrl: './unsubscribe.component.html',
    styleUrls: ['./unsubscribe.component.scss']
  })
  export class UnsubscribeComponent implements OnInit, OnDestroy {
    subs: Subscription[] = [];
    isEnabled: boolean = false;
    unsubscribeForm: UntypedFormGroup;
    company:CompanyDetails;
    dialogRef: MatDialogRef<any>;
    currentUser: InfoPerso

    @ViewChild('dialog') dialogContent: TemplateRef<any>;
    @ViewChild('phoneNumber') phoneNumberField: NgxMatIntlTelInputComponent;

    constructor(private storageService: StorageService, private dialog: MatDialog, private fb: UntypedFormBuilder, private customerService: CustomerServiceService, private loadingService: GS1LoadingService) {}

    ngOnInit(): void {
      this.loadUser();
      this.loadCompany();
    }

    async loadCompany() {
      this.company = await this.storageService.getCompany();
    }

    async loadUser() {
      this.currentUser = await this.storageService.getUser();
      this.isEnabled = this.storageService.isUserAdmin();
    }

    constructForm(user:InfoPerso)
    {
      this.unsubscribeForm = this.fb.group({
        acceptUnsubscribe: ['', Validators.required],
        reason: ['', Validators.required],
        // comment: ['', Validators.compose([Validators.minLength(5), Validators.maxLength(200)])],
        firstName: [user.prenom, Validators.compose([Validators.required, Validators.minLength(2), Validators.pattern(/[A-Za-zà-ù\-\s]+/)])],
        lastName: [user.nom, Validators.compose([Validators.required, Validators.minLength(2), Validators.pattern(/[A-Za-zà-ù\-\s]+/)])],
        phoneNumber: [user.telPrincipal, Validators.required]
      });

      this.subs.push(this.unsubscribeForm.get('reason').valueChanges.subscribe((value: string) => {
        this.updateCommentValidators(value)
      }));
    }

    updatePhoneField(value: string) {
      this.unsubscribeForm.get('phoneNumber').markAsDirty();
      this.unsubscribeForm.get('phoneNumber').markAsTouched();
      this.phoneNumberField.writeValue(value);
      this.phoneNumberField.onPhoneNumberChange();
      this.unsubscribeForm.get('phoneNumber').setValue(this.phoneNumberField.numberInstance.number);
      this.unsubscribeForm.get('phoneNumber').updateValueAndValidity();                                               
    }

    updateCommentValidators(value: string) {
      if(value === 'autre') {
        this.unsubscribeForm.get('comment').clearValidators();
        this.unsubscribeForm.get('comment').setValidators(Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(200)]));
      } else {
        this.unsubscribeForm.get('comment').clearValidators();
        this.unsubscribeForm.get('comment').setValidators(Validators.compose([Validators.minLength(5), Validators.maxLength(200)]));
      }
      this.unsubscribeForm.get('comment').updateValueAndValidity();
      this.unsubscribeForm.updateValueAndValidity();
    }
  
    ngOnDestroy(): void {
      this.subs.forEach(sub => sub.unsubscribe());
    }

    showUnsubscribePopin(): void {
      this.constructForm(this.currentUser);
      const dialogOption: MatDialogConfig = new MatDialogConfig();
      dialogOption.width = "670px";
      dialogOption.maxWidth = "95vw";
      dialogOption.autoFocus = false;
      dialogOption.panelClass = "unsubscribe-dialog";
      dialogOption.disableClose = false;
      this.dialogRef = this.dialog.open(this.dialogContent, dialogOption);
    }

    closeUnsubscribePopin(): void {
      this.dialog.closeAll();
    }

    async askUnsubscribe() {
      if (this.unsubscribeForm.valid) {
        this.loadingService.startLoading('unsubscribe');
        const form = new FormData();
        const data = this.unsubscribeForm.value;
        for (const key in data) {
          form.append(key, data[key]);
        }
        try {
          await this.customerService.unsubscribe(data);
        } finally {
          this.loadingService.stopLoading('unsubscribe');
          this.dialogRef.close();
        }
      }
    }
    
    close() {
      this.dialogRef.close();
    }

    stepChanged(step: any) {
      if(step.selectedIndex === 2) {
        this.updatePhoneField(this.currentUser.telPrincipal)
      }
    }

  }